import _ from 'lodash';
import { Loading, NotFound } from '~';
import { mapActions, mapState, mapGetters } from 'vuex';
import BoxWidget from '@/components/box-widget/BoxWidget.vue';
import NotificationsBox from '@/components/notifications-box/NotificationsBox.vue';
import CustomerInfo from '@/components/customer-info/CustomerInfo.vue';
import Campaigns from '@/components/customer/campaigns/Campaigns.vue';

export default {
  components: {
    NotFound,
    loading: Loading,
    'box-widget': BoxWidget,
    notifications: NotificationsBox,
    'customer-info': CustomerInfo,
    campaigns: Campaigns,
  },
  data() {
    return {
      customerFields: ['remoteId', 'name', 'email', 'phone'],
    };
  },
  computed: {
    ...mapGetters('customer', {
      customer: 'currentCustomer',
    }),
    ...mapState('customer', [
      'notificationsLoading',
      'notifications',
      'campaignsLoading',
      'campaigns',
      'loading',
      'error',
    ]),
  },
  methods: {
    ...mapActions('customer', ['getCustomer', 'getMoreNotifications', 'getMoreCampaigns']),
    createNotificationText(item) {
      return this.$t('pos.customer.notifications', {
        template: item.template_name,
        date: item.created_at,
        to: item.type === 'email' ? item.target_addresses : item.target_numbers,
      });
    },
    updateCustomerData() {
      this.getCustomer(this.$route.params.id)
        .then(() => this.getMoreNotifications())
        .catch(_.noop);
    },
  },
  mounted() {
    this.updateCustomerData();
  },
  watch: {
    $route: function watchRoute() {
      this.updateCustomerData();
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/customer/Customer.js